import type { FC } from 'react';

export interface StoreRevampLayoutProps {
  pageTitle: React.ReactNode;
  navigation: React.ReactNode;
  content: React.ReactNode;
  flagShip: React.ReactNode;
  exchange: React.ReactNode;
  currencySwitch: React.ReactNode;
  balance: React.ReactNode;
  eventBar: React.ReactNode;
}

export const StoreRevampLayout: FC<StoreRevampLayoutProps> = ({
  pageTitle,
  navigation,
  flagShip,
  content,
  exchange,
  currencySwitch,
  balance,
  eventBar,
}) => {
  return (
    <div className="font-poppins pb-20">
      <div className="flex items-center justify-between pb-5">
        <div className="flex w-full flex-row justify-between gap-4">
          <div className="text-text300 text-base font-semibold md:text-xl">
            {pageTitle}
          </div>
          <div className="hidden flex-1 flex-col justify-end gap-5 md:flex md:flex-row">
            <div className="max-w-[340px] flex-1">{currencySwitch}</div>
            <div>{exchange}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5">
        {balance}

        <div className="flex flex-col gap-2 pb-1 md:hidden">
          {exchange}
          {currencySwitch}
        </div>

        {eventBar}
        <div className="-mt-4 md:mt-0">
          {flagShip && <div>{flagShip}</div>}
          {navigation}
          <div className="flex flex-col gap-y-6">{content}</div>
        </div>
      </div>
    </div>
  );
};
